import React, { Component } from 'react'
import { Link } from "react-router-dom";
import { connect } from "react-redux"
import { Field, reduxForm, FormSection } from 'redux-form'

import Svg from '../components/Svg';
import Aux from '../containers/AuxContainer'

const CheckinField = ({ input, className, id, label, type, meta: { touched, error, warning } }) => {
	return (
		<Aux>
		<div className="switch radius tiny float-left">
      <input 
      	{...input}
      	className="switch-input" 
      	id="checkin-enabled" 
      	type={type} />
      <label className="switch-paddle" htmlFor="checkin-enabled">
        <span className="show-for-sr">{label}</span>
      </label>
    </div>
    <label htmlFor="checkin-enabled" className="float-left switch-label">{label}</label>
    </Aux>
	)
}

const CheckboxField = ({ input, className, id, label, type, meta: { touched, error, warning }, ...rest }) => {
	return (
		<li>
			<input 
				{...input} 
				{...rest} 
			  type={type}
				className="styled-checkbox" 
				id={id} />
	    <label htmlFor={id}>{label}</label>
		</li>
	)
}


class ProjectSettingsForm extends Component {
	render() {
		const { handleSubmit, errors, submitting, pristine, updateSuccess, settings } = this.props
		return (
			<form id="project-settings-form" onSubmit={ handleSubmit }>
				<FormSection name="project">
				<section id="project-settings" className="section-project-settings gray-bg section">
		  
				  <div className="grid-x align-center">
				    <div className="small-12  medium-6 cell">
							{updateSuccess && <p className="green-text text-center">
							You have successfully updated settings</p>}

				      	<Field 
				      		type="checkbox"
				      		name="checkin_enabled"
				      		component={CheckinField}
				      		label="Check-in activated" />
				    </div>
				  </div>

				  <div className="grid-x align-center">
				    <div className="small-12  medium-6 cell">
				    	<ul className="unstyled">
				    		
				    		<Field 
				    			disabled
				    			type="checkbox" 
				    			component={CheckboxField} 
				    			label="Allow Check-in from Artist Device"
				    			id="allow_checkin_artist_device"
				    			name="allow_checkin_artist_device" />

				    		<Field 
				    			type="checkbox" 
				    			component={CheckboxField} 
				    			label="Allow NEW Artist to register (not already scheduled to audition)"
				    			id="allow_new_artist_checkin"
				    			name="allow_new_artist_checkin" />

				    		<Field 
				    			disabled
				    			type="checkbox" 
				    			component={CheckboxField} 
				    			label="Include Artist statistics in Check-in"
				    			id="include_artist_statistics_Checking"
				    			name="include_artist_statistics_Checking" />

				    		<Field 
				    			disabled
				    			type="checkbox" 
				    			component={CheckboxField} 
				    			label="Require signature and timestamp from Artists in Check-in"
				    			id="require_signature_timestamp_checkin"
				    			name="require_signature_timestamp_checkin" />

				    		{
				    			// <Field 
				    			// disabled
				    			// type="checkbox" 
				    			// component={CheckboxField} 
				    			// label="Save check-in forms as PDF's for download in APP by users"
				    			// id="save_pdf_download_app_users"
				    			// name="save_pdf_download_app_users" />
				    		}

				    		<Field 
				    			disabled
				    			type="checkbox" 
				    			component={CheckboxField} 
				    			label="Send Confirmation email as Artist Check-in"
				    			id="send_confirmation_email_artist_checkin"
				    			name="send_confirmation_email_artist_checkin" />

				    		{
				    			// <Field 
					    		// 	disabled
					    		// 	type="checkbox" 
					    		// 	component={CheckboxField} 
					    		// 	label="Show Checked in icon with timestamps as each Artist completes Check-in"
					    		// 	id="show_checkedin_icons"
					    		// 	name="show_checkedin_icons" />
					    	}

				    		<Field 
				    			disabled
				    			type="checkbox" 
				    			component={CheckboxField} 
				    			label="Require Admin password before each Artist starts Check-in"
				    			id="require_admin_password_start_checkin"
				    			name="require_admin_password_start_checkin" />
				    	</ul>
				    </div>
				  </div>

				</section>

				<section className="text-center section">
					<button className="button primary" 
						type="submit" 
						disabled={pristine || submitting}>
							{submitting ? 'Saving Project Settings...' : 'Save Settings' }
					</button>
		  	</section>
		  	</FormSection>
			</form>
		)	
	}
}

ProjectSettingsForm = reduxForm({
  // a unique name for the form
  form: 'ProjectSettingsForm'
})(ProjectSettingsForm)

const mapStateToProps = state => ({
	initialValues: { 
		project: {
			checkin_enabled: state.client.project.checkin_enabled,
			allow_new_artist_checkin: state.client.project.allow_new_artist_checkin,
		}
	}
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectSettingsForm);


// WEBPACK FOOTER //
// ./src/components/ProjectSettingsForm.js